import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=e27c574c"
import script from "./BaseAddress.vue?vue&type=script&lang=js"
export * from "./BaseAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports